import React from 'react'
import styled from 'styled-components'

import { getToken } from 'theming'
import conditional, { whenProps } from 'tools/conditional'
import prop from 'tools/prop'
import transition from 'styles/transition'
import hoverable from 'styles/hoverable'
import focusable from 'styles/focusable'
import disableable from 'styles/disableable'
import hidden from 'styles/hidden'

import { StackProps, Stack } from 'components/Layout/Stack'
import { Icon } from 'components/Icon'

import type { DropZoneProps } from './types'

export const DragDropFileWrapper = styled(Stack)<{ withFileList: boolean }>`
  width: 100%;

  & > label + p {
    margin-top: ${conditional({
      'space-m': whenProps({ withFileList: true }),
      'space-l': whenProps({ withFileList: false }),
    })};
  }
`

export const DropZoneWrapper = styled((props: StackProps) => <Stack as="label" {...props} />)<
  Pick<DropZoneProps, 'disabled' | 'error'>
>`
  ${transition({ property: 'border-color, box-shadow, opacity' })}

  cursor: pointer;

  background-color: ${getToken('color-neutral-white')};
  border-radius: ${getToken('border-radius-s')};
  border: 2px dashed;
  border-color: ${conditional({
    'color-neutral-light': whenProps({ error: false }),
    'color-danger': whenProps({ disabled: false, error: true }),
  })};

  padding: ${getToken('space-l')} ${getToken('space-3xl')};

  text-align: center;

  ${hoverable`
    border-color: ${conditional({
      'color-accent': whenProps({ disabled: false, error: false }),
    })};
  `}

  ${focusable`
    border-color: ${conditional({
      'color-accent': whenProps({ disabled: false, error: false }),
    })};
    box-shadow: ${getToken('shadow-glow-primary')};
  `}

  ${disableable()}
`

export const HiddenInput = styled.input`
  ${hidden()}
`

export const UploadIcon = styled(Icon)`
  color: ${getToken('color-neutral')};
`

export const FileListUL = styled((props: StackProps) => <Stack as="ul" {...props} />)`
  padding: 0;
`

export const Divider = styled.div`
  width: 1px;
  height: 16px;

  background-color: ${getToken('color-neutral-darker')};
`
